import React, { Component, Fragment } from "react";
import styled from "styled-components";
import { Icon, Menu, MenuList, MenuItem } from "@material-ui/core";
import { FlexBox } from "js/react/components/LayoutGrid";
import { FlexSpacer } from "js/react/components/Gap";

export class NestedMenuItem extends Component {
    state = {
        anchorEl: null
    }

    constructor() {
        super();
        this.ref = React.createRef();
    }

    handleShowMenu = () => {
        this.setState({ anchorEl: this.ref.current });
    }

    handleCloseMenu = () => {
        this.setState({ anchorEl: null });
    }

    render() {
        let { id, icon, label, contents, showNestedOnClick = false, disabled } = this.props;
        let { anchorEl } = this.state;

        let anchorOrigin, transformOrigin;

        if (anchorEl && anchorEl.getBoundingClientRect().right > window.innerWidth - 200) {
            anchorOrigin = { vertical: "top", horizontal: "left" };
            transformOrigin = { vertical: "top", horizontal: "right" };
        } else {
            anchorOrigin = { vertical: "top", horizontal: "right" };
            transformOrigin = { vertical: "top", horizontal: "left" };
        }

        return (
            <MenuItem
                id={id}
                ref={this.ref}
                onMouseDown={showNestedOnClick ? this.handleShowMenu : null}
                onMouseEnter={showNestedOnClick ? null : this.handleShowMenu}
                onMouseLeave={showNestedOnClick ? null : this.handleCloseMenu}
                style={{ paddingRight: 5, display: "block" }}
                disabled={disabled}
            >
                <FlexBox fillWidth left middle
                >
                    {icon}
                    {label}
                    {contents}
                    <FlexSpacer/>
                    <Icon>keyboard_arrow_right</Icon>
                </FlexBox>

                <Menu
                    className="nested-menu"
                    style={{ pointerEvents: showNestedOnClick ? "auto" : "none" }}
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    anchorOrigin={anchorOrigin}
                    transformOrigin={transformOrigin}
                    onClose={this.handleCloseMenu}
                >
                    <div style={{ pointerEvents: "auto" }}>
                        {this.props.children}
                    </div>
                </Menu>
            </MenuItem>
        );
    }
}
